import { useState } from 'react';
import InnerLayout from '../../Layout/InnerLayout';
import styles from './style/Lists.module.scss';
import { MdEditNote } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import Button from '../../Utilities/Button';
import Paginate from '../../Utilities/Paginate';
import EmptyBox from '../../Utilities/EmptyBox';

import { useEffect } from 'react';
import { askBatchImport, deleteASK, getASKList, resetSuccess, updateError } from '../../../store/slice/tdp/ask';
import ModalBlueprint from './ModalBlueprint';
import { useSelector } from 'react-redux';
import Alert from '../../Utilities/Alert';
import Tips from '../../Utilities/Tips';
import { BsSearch } from 'react-icons/bs';
import { IoAddOutline } from 'react-icons/io5';
import Dropdown from '../../Utilities/DropdownDynamic';
import { VscGlobe } from 'react-icons/vsc';
import { getBlueprintList, selectBlueprint } from '../../../store/slice/tdp/blueprint';
import { getListsLanguage, selectMultilingual } from '../../../store/slice/language/multilingual';

const PAEISettings = () => {
  const dispatch = useDispatch();
  const { lists } = useSelector(selectMultilingual);
  const { blueprint_lists, loading, error } = useSelector(selectBlueprint);
  const params = useParams();

  const [isOpen, setIsOpen] = useState(false);
  const [detail, setDetail] = useState('');

  const [removeId, setRemoveId] = useState('');
  const [category] = useState('');
  const [keyword, setKeyword] = useState('');
  const [errorUpload, setErrorUpload] = useState(false);

  const [options, setOptions] = useState([]);
  const [choose, setChoose] = useState('繁體中文');
  const [code, setCode] = useState({
    text: '繁體中文',
    value: 1,
    code: 'zh-TW',
  });

  const [title, setTitle] = useState('公司目標模板');
  const [page, setPage] = useState(1);
  const [isAlert, setIsAlert] = useState(false);
  const limit = 10;

  useEffect(() => {
    dispatch(getListsLanguage());
  }, [dispatch]);

  useEffect(() => {
    const array = [];
    lists?.data?.forEach((item) => {
      array.push({ text: item.language, value: item.id, code: item.code });
    });
    setOptions(array);
  }, [lists]);

  const handleChangeLanguage = (value) => {
    setChoose(value?.text);
    setCode(value);
  };

  useEffect(() => {
    setPage(1);
    let postObj = '';
    if (params.reference === 'goal') {
      setTitle('公司目標模板');
      postObj = {
        page: 1,
        limit: 10,
        type: 'category',
        search: keyword,
        code: code?.value,
        parent_id: null,
      };
    }
    if (postObj) dispatch(getBlueprintList(postObj));
  }, [params.reference, dispatch, keyword, code]);

  const pageChangeHandler = (e) => {
    setPage(parseInt(e.selected + 1));
    const postObj = {
      page: e.selected + 1,
      page_length: limit,
      category: category,
      key_word: keyword,
    };
    dispatch(getASKList(postObj));
  };

  const getUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      let obj = {
        file: e.target.files[0],
      };
      dispatch(askBatchImport(obj));
      reader.readAsArrayBuffer(e.target.files[0]);
      e.target.value = '';
    }
  };

  useEffect(() => {
    if (!error) return;
    setIsAlert(true);
    dispatch(updateError());
  }, [dispatch, error]);

  const handleRemove = () => {
    const postObj = {
      askID: removeId,
    };
    dispatch(deleteASK(postObj));
    setRemoveId('');
  };

  return (
    <InnerLayout>
      <div className={styles.dashboardOuter}>
        <div className={styles.header}>
          <div className={styles.title}>經營藍圖模板</div>
        </div>

        <div className={styles.tabContainer}>
          <div className={styles.searchOutline}>
            <input
              type='text'
              placeholder='搜尋職能項目'
              className='searchInput'
              onChange={(e) => setKeyword(e.target.value)}
              value={keyword}
              // onKeyUp={handleFilterEnter}
            />
            <div
              className={styles.BsSearch}
              // onClick={handleFilter}
            >
              <BsSearch />
            </div>
          </div>
        </div>

        <div className={styles.tableContainer}>
          <div className={styles.title}>
            {title}

            <div className={styles.actionButton}>
              <div className={styles.searchOutline}>
                <input
                  type='text'
                  placeholder='搜尋模板項目'
                  className='searchInput'
                  onChange={(e) => setKeyword(e.target.value)}
                  value={keyword}
                  // onKeyUp={handleFilterEnter}
                />
                <div
                  className={styles.BsSearch}
                  // onClick={handleFilter}
                >
                  <BsSearch />
                </div>
              </div>

              <span style={{ display: 'none' }}>
                <Button type='primary' icon={<IoAddOutline fontSize={20} />} title={`新增${title}`} onClick={() => {}} />
              </span>

              <span>
                <Dropdown
                  icon={<VscGlobe className={styles.icon} />}
                  color={'#5856d6'}
                  background={'#DFDFF7'}
                  placeholder='全部'
                  value={choose}
                  listItems={options}
                  onChange={(e) => handleChangeLanguage(e)}
                  caption={'text'}
                />
              </span>
            </div>
          </div>

          <table>
            <thead>
              <tr>
                <th>公司目標類別</th>
                <th width='30%'>原始資料</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {blueprint_lists?.rows?.length > 0 ? (
                blueprint_lists?.rows?.map((data, index) => (
                  <tr key={index}>
                    <td>{data[code?.code]}</td>
                    <td>
                      <span className={styles.textPurple}>{data.category}</span>
                    </td>
                    <td>
                      <div className={styles.buttonWrapper}>
                        <span>
                          <Tips detail={'查看職能慣性項目'}>
                            <Button
                              type='pure'
                              icon={<MdEditNote />}
                              onClick={() => {
                                setDetail(data);
                                setIsOpen(true);
                              }}
                              disabled={loading}
                            />
                          </Tips>
                        </span>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3}>
                    <EmptyBox caption={'無資料'} type={3} height={300} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {blueprint_lists?.total > 0 && (
          <Paginate
            onPageChange={pageChangeHandler}
            pageCount={page}
            limit={limit}
            totalPages={Math.ceil(blueprint_lists.total / 10)}
            totalData={blueprint_lists.total}
          />
        )}
      </div>

      <ModalBlueprint detail={detail} setDetail={setDetail} setIsOpen={setIsOpen} isOpen={isOpen} code={code} />

      <Alert
        isOpen={removeId}
        onConfirm={handleRemove}
        onClose={() => setRemoveId('')}
        rightButtonText={'刪除'}
        leftButtonText='取消'
        mainTitle={`確認刪除該職能項目？`}
        isWarning={true}
      />

      <Alert
        uploadFile
        isOpen={errorUpload}
        onConfirm={getUploadFile}
        onClose={() => {
          setErrorUpload(false);
          dispatch(resetSuccess());
        }}
        rightButtonText={'重新上傳'}
        leftButtonText={'取消'}
        mainTitle={`此檔案不符合格式`}
        subTitle={`請下載範本進行編輯，並且以 xls,xlsb,xlsx 之檔案格式上傳`}
      />

      <Alert
        isOpen={isAlert}
        onClose={() => setIsAlert(false)}
        onConfirm={() => setIsAlert(false)}
        mainTitle={`　　該職能項目有企業正在使用　　無法刪除！`}
        subTitle={''}
        rightButtonText='關閉'
      />
    </InnerLayout>
  );
};
export default PAEISettings;
